module.exports = __webpack_public_path__ + "img/CHNT.473f69d2.png";